import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { fullDateFullYearFormat } from "@common/helpers/date";
import { parseISO, format } from "date-fns";
import { ClientsCloseOverviewRow } from "../clientsCloseOverviewViewConfig";

export const CreatedAtCell = ({
    row,
    getValue,
}: CellContext<
    ViewTableFeatures,
    ClientsCloseOverviewRow,
    string | undefined
>) => {
    if (row.original.rowType !== "workspace") {
        return null;
    }

    const value = getValue();

    if (!value) {
        return "-";
    }

    const formattedDate = format(parseISO(value), fullDateFullYearFormat);

    return <ViewTableCell>{formattedDate}</ViewTableCell>;
};

CreatedAtCell.displayName = "CreatedAtCell";
